// extracted by mini-css-extract-plugin
module.exports = {" _key":"dojo2-todo-mvc-kitchensink/todoSearch","search":"todoSearch-m__search__1Z0gL","searchIcon":"todoSearch-m__searchIcon__yAaPh"};